import { NgModule } from '@angular/core';
import { NbIconLibraries } from '@nebular/theme';
import { NbIonIcons } from './ion-icons';

@NgModule()
export class NbIonFaIconsModule {
  constructor(iconLibrary: NbIconLibraries) {
    iconLibrary.registerFontPack('fa', { packClass: 'fa', iconClassPrefix: 'fa' });
    iconLibrary.registerFontPack('far', { packClass: 'far', iconClassPrefix: 'fa' });
    iconLibrary.registerFontPack('fab', { packClass: 'fab', iconClassPrefix: 'fa' });
    iconLibrary.registerSvgPack('ion', NbIonIcons);

    // Register the default (filled) Material Icons
    iconLibrary.registerFontPack('mati', {
      ligature: true,
      iconClassPrefix: 'material-ico',
      packClass: 'material-icons',
    });

    // Register the Material Icons Outlined
    iconLibrary.registerFontPack('matio', {
      ligature: true,
      iconClassPrefix: 'material-ico',
      packClass: 'material-icons-outlined',
    });

    // Register the Material Icons Rounded
    iconLibrary.registerFontPack('matir', {
      ligature: true,
      iconClassPrefix: 'material-ico',
      packClass: 'material-icons-round',
    });

    // Register the Material Icons Two-tone
    iconLibrary.registerFontPack('matit', {
      ligature: true,
      iconClassPrefix: 'material-ico',
      packClass: 'material-icons-two-tone',
    });

    // Register the Material Icons Sharp
    iconLibrary.registerFontPack('matis', {
      ligature: true,
      iconClassPrefix: 'material-ico',
      packClass: 'material-icons-sharp',
    });
  }
}
